<template>
  <div class="pic flex_row_center">
    <div class="pic-main" style="width:100%;">
      <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="3000"
        controls
        indicators
        background="#ababab"
        img-width="1024"
        img-height="480"
        style="text-shadow: 1px 1px 2px #333;"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide v-for="item in lunbo" v-bind:key="item.index">
          <template v-slot:img>
            <img
              class="d-block img-fluid w-100"
              width="1024"
              height="480"
              v-lazy="item.src"
              alt="image slot"
            />
          </template>
        </b-carousel-slide>
      </b-carousel>
    </div>
  </div>
</template>

<script>

var global = require("@/utils/global");

export default {
  name: "pic",

  data() {
    return {
      slide: 0,
      sliding: null,
      lunbo: [
        // {
        //   //          src: require("./../../assets/2_banner@2x.png")
        //   // src: global.pictureBaseUrl + "/2_banner@2x.png"
        //   src: global.pictureBaseUrl + "/banner_new_1.jpg"
        // },
        {
          //          src: require("./../../assets/banner2.jpg")
//          src: global.pictureBaseUrl + "/banner2.jpg"
            // src: global.pictureBaseUrl + "/2023.jpg"
            src: global.pictureBaseUrl + "/top/主页1.jpg"


        },
        {
          //          src: require("./../../assets/banner3.jpg")
//          src: global.pictureBaseUrl + "/banner3.jpg"
          // src: global.pictureBaseUrl + "/banner21.jpg"
          src: global.pictureBaseUrl + "/top/主页第二张更换.jpg"
        }
      ]
    };
  },
  mounted() {
    var fenbian = document.documentElement.clientWidth;
    if (fenbian < 500) {
      this.lunbo[0].src = global.pictureBaseUrl + "/top/主页1.jpg?x-oss-process=image/resize,m_fill,w_860,h_350";
      this.lunbo[1].src = global.pictureBaseUrl + "/top/主页第二张更换.jpg?x-oss-process=image/resize,m_fill,w_860,h_350";
      // this.lunbo[2].src = global.pictureBaseUrl + "/xiao3.jpeg";
    }
    // console.log(document.documentElement.clientWidth);
    // const that = this;
    // window.onresize = () => {
    //   return (() => {
    //     console.log(document.documentElement.clientWidth);
    //   })();
    // };
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pic {
  color: #fff;
}
.pic-main {
  width: 100%;
}
.pic-main img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/public/pic.vue